module.exports = __webpack_public_path__ + "svg/new-maestro-small.b1bb988e04c8d22923093f2d1829ee25.svg";